import * as React from "react";
import { Icon } from "sb-resp-ui";
const baseClass = "rj-yourbet__remove";
export class Remove extends React.Component {
    render() {
        const { modifier, datauat, icon, handler } = this.props;
        const cls = `${baseClass}` + (modifier ? ` ${baseClass}--${modifier}` : "");
        return (React.createElement("button", { type: "button", className: cls, "data-uat": "delete-bet", onClick: handler },
            React.createElement(Icon, { i: icon, "data-uat": datauat })));
    }
}
//# sourceMappingURL=Remove.js.map